<template>
  <div id="system-filter">
    <button
      type="button"
      :class="[
        show || isFilterActive(activeFilters) ? 'active' : '',
        'system-filter-container',
      ]"
      @click="handleToggle()"
    >
      <span v-if="!isFilterActive(activeFilters)">Select Filters</span>
      <span v-else>Active Filters</span>
      <img
        v-if="!show && !isFilterActive(activeFilters)"
        class="down"
        src="@shared/assets/img/table/chevron-down.svg"
        alt="Open"
      >
      <img
        v-else
        class="down"
        src="@shared/assets/img/table/chevron-down-white.svg"
        alt="Open"
      >
    </button>
    <div
      :class="[
        show ? 'active' : '',
        'system-dropdown-container',
      ]"
    >
      <div class="filter-category">
        <ThermostatZoneFilter v-if="activeTab !== 'runtime' && activeTab !== 'deltaT'" />
        <SingleTZoneFilter v-if="activeTab === 'runtime' || activeTab === 'deltaT'" />
        <CycleTypeFilter v-if="activeTab === 'cycle'" />
        <DateFilter v-if="activeTab === 'cycle' || activeTab === 'runtime'" />
        <AlertCategoryFilter v-if="activeTab === 'alerts'" />
      </div>
      <div class="dropdown-footer">
        <button
          type="button"
          class="clear-btn"
          @click="clearAllFilters()"
        >
          Clear All
        </button>
        <button
          type="button"
          class="apply-btn"
          @click="applyFilters()"
        >
          Apply
        </button>
      </div>
    </div>
    <div class="active-filter">
      <div
        v-if="activeTZone.length && (activeTab !== 'runtime' && activeTab !== 'deltaT')"
        class="active-filter-label"
      >
        <div
          v-for="(uid, idx) in activeTZone"
          :key="idx"
        >
          <div class="a-f-tag">
            T Zone: {{ uid.uId.slice(uid.uId.length - 4) }}
          </div>
        </div>
      </div>
      <div
        v-if="activeSingleTZone && (activeTab === 'runtime' || activeTab === 'deltaT')"
        class="active-filter-label"
      >
        <div class="a-f-tag">
          T Zone: {{ activeSingleTZone }}
        </div>
      </div>
      <div
        v-if="activeCycleType.length && (activeTab === 'cycle' || activeTab === 'deltaT')"
        class="active-filter-label"
      >
        <div
          v-for="(type, idx) in activeCycleType"
          :key="idx"
        >
          <div class="a-f-tag">
            Cycle: {{ type }}
          </div>
        </div>
      </div>
      <div
        v-if="activeDeltaT.length
          && ((activeTab === 'cycle' && cycleViewTab === 'table')
            || cycleViewTab === 'chart')"
        class="active-filter-label"
      >
        <div
          v-for="(dt, idx) in activeDeltaT"
          :key="idx"
        >
          <div class="a-f-tag">
            ΔT: {{ dt }}
          </div>
        </div>
      </div>
      <div
        v-if="activeDate && (activeTab === 'cycle' || activeTab === 'runtime')"
        class="active-filter-label"
      >
        <div class="a-f-tag">
          Days: {{ activeDate }}
        </div>
      </div>
      <div
        v-if="activeDateRange.start"
        class="active-filter-label"
      >
        <div class="a-f-tag">
          Days: {{ formattedDate(activeDateRange.start) }} --
          {{ formattedDate(activeDateRange.end) }}
        </div>
      </div>
      <div
        v-if="activeAlertCategory.length && activeTab === 'alerts'"
        class="active-filter-label"
      >
        <div
          v-for="(ca, idx) in activeAlertCategory"
          :key="idx"
        >
          <div class="a-f-tag">
            Alert: {{ ca }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import ThermostatZoneFilter from './systemFilters/ThermostatZoneFilter.vue';
import CycleTypeFilter from './systemFilters/CycleTypeFilter.vue';
import DateFilter from './systemFilters/DateFilter.vue';
import AlertCategoryFilter from './systemFilters/AlertCategoryFilter.vue';
import SingleTZoneFilter from './systemFilters/SingleTZoneFilter.vue';

export default {
  name: 'CycleSystemFilter',
  components: {
    SingleTZoneFilter,
    AlertCategoryFilter,
    DateFilter,
    CycleTypeFilter,
    ThermostatZoneFilter,
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    ...mapState({
      systemFilterOptions: (state) => state.customerDetail.systemFilterOptions,
      activeFilters: (state) => state.customerDetail.systemFilter,
      activeTab: (state) => state.customerDetail.activeTab,
      cycleViewTab: (state) => state.customerDetail.cycleViewTab,
      activeTZone: (state) => state.customerDetail.systemFilterRef.thermostatZone,
      activeSingleTZone: (state) => state.customerDetail.systemFilterRef.singleTZone,
      activeCycleType: (state) => state.customerDetail.systemFilterRef.cycleTypeFilter,
      activeDeltaT: (state) => state.customerDetail.systemFilterRef.deltaTFilter,
      activeDate: (state) => state.customerDetail.systemFilterRef.dateFilter,
      activeAlertCategory: (state) => state.customerDetail.systemFilterRef.alertCategoryFilter,
      activeDateRange: (state) => state.customerDetail.systemFilterRef.dateRange,
    }),
  },
  mounted() {
    document.querySelector(':not(.system-dropdown-container)').addEventListener('click', this.closeOnClick);
  },
  destroyed() {
    document.querySelector(':not(.system-dropdown-container)').removeEventListener('click', this.closeOnClick);
  },
  methods: {
    formattedDate(d) {
      if (d) {
        return moment(d).format('MM/DD/YYYY');
      }
      return '--';
    },
    handleToggle() {
      if (this.systemFilterOptions.length) {
        this.show = !this.show;
      }
    },
    applyFilters() {
      this.$store.dispatch('applySystemFilters');
      this.show = !this.show;
    },
    clearAllFilters() {
      this.$store.dispatch('clearAllSystemFilters');
      this.show = !this.show;
    },
    closeOnClick(e) {
      if (!e.target.closest('.system-filter-container') && !e.target.closest('.system-dropdown-container') && this.show) {
        this.show = false;
        this.$store.dispatch('resetToRefFilter');
      }
    },
    isFilterActive(filters) {
      return !!(filters.thermostatZone.length
        || filters.cycleTypeFilter.length
        || filters.deltaTFilter.length
        || filters.alertCategoryFilter.length
        || filters.singleTZone);
    },
  },
};
</script>

<style lang="scss">

#system-filter {
  position: relative;
  user-select: none;
  display: grid;
  grid-auto-flow: column;
  gap: 1rem;
  align-items: center;

  .system-filter-container {
    min-width: 108px;
    height: 32px;
    background-color: $WHITE;
    border-radius: 2px;
    padding-left: 8px;
    padding-right: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    &.active {
      background-color: $PRIMARY;
      color: WHITE;
    }

    span {
      font-size: 12.64px;
    }

    .down {
      width: 15px;
      height: 15px;
    }
  }

  .system-dropdown-container {
    position: absolute;
    left: 0;
    top: 30px;
    padding: 1rem 2rem;
    border-radius: 4px;
    background-color: $WHITE;
    box-shadow: 0 0 4px rgba(20, 33, 69, 0.1);
    display: flex;
    flex-direction: column;
    transition: transform 0.1s ease;
    transform: scaleY(0);
    transform-origin: top;
    z-index: 10;

    &.active {
      height: auto;
      transform: scaleY(1);
    }

    .filter-category {
      display: grid;
      grid-auto-flow: column;
      gap: 1rem;

      .filter-label {
        padding: 5px 10px;
        color: $N90;
        font-weight: 600;
        text-transform: uppercase;
        white-space: nowrap;
      }

      .filter-options {
        display: grid;
        gap: 8px;
        margin-top: 10px;
        padding: 4px 10px;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 8px;
        cursor: pointer;
        max-height: 250px;
        overflow: auto;

        .option {
          font-weight: 500;
          color: $N100;
          font-size: 1rem;
          padding: 2px 10px;
          border-radius: 6px;
          border: 1px solid $NBLUE20;
          white-space: nowrap;

          &:hover {
            background-color: $NBLUE10;
          }

          &.active {
            background-color: $NBLUE100;
            color: $WHITE;
          }

          &.disabled {
            background-color: $N5;
            color: $N10;
            cursor: default;
          }
        }

        .all-zone {
          text-align: center;
          background-color: $NBLUE10;
          padding: 2px 10px;
          border-radius: 6px;
          font-weight: 500;

          &.active {
            color: $WHITE;
            background-color: $NBLUE100;
          }
        }

        .range-container {
          display: flex;
          position: relative;

          .date-container {
            .date {
              display: flex;
              align-items: center;
              padding-left: 9px;
              padding-right: 9px;
              width: 107px;
              height: 32px;
              background-color: $NBLUE10;
              font-size: 12.64px;

              .calendar {
                width: 15px;
                height: 15px;
                margin-right: 8px;
              }

              span {
                width: 100%;
                text-align: center;
              }
            }
          }

          .line-divider {
            width: 34px;
            height: 1px;
            background-color: $BLACK;
            margin-left: 11px;
            margin-right: 11px;
            margin-top: 40px;
          }

          .date-picker {
            position: absolute;
            width: 100%;
            left: 0;
            bottom: 0;

            input {
              opacity: 0;
            }
          }
        }
      }
    }

    .center {
      justify-content: center;
      color: $BLACK;
      background: $NBLUE10;
    }

    .dropdown-footer {
      display: grid;
      grid-auto-flow: column;
      justify-content: flex-end;
      gap: 10px;
      border-top: 1px solid $N10;
      padding: 10px;

      .clear-btn {
        padding: 4px 10px;
        background-color: $NBLUE20;
        border-radius: 6px;
        font-weight: bold;
      }

      .apply-btn {
        padding: 4px 10px;
        background-color: $NBLUE100;
        color: $WHITE;
        border-radius: 6px;
        font-weight: 500;
      }
    }
  }

  .active-filter {
    display: grid;
    grid-auto-flow: column;
    gap: 5px;

    .active-filter-label {
      display: grid;
      grid-auto-flow: column;
      align-items: center;
      gap: 5px;

      .a-f-tag {
        background-color: $NBLUE10;
        padding: 3px 10px;
        border-radius: 12px;
        border: 1px solid $NBLUE100;
        color: $NBLUE100;
        font-weight: 600;
        font-size: 14px;
      }
    }
  }
}
</style>
